export const FETCH_COURSE_ADMIN_DATA_START = 'FETCH_COURSE_ADMIN_DATA_START';
export const FETCH_COURSE_ADMIN_DATA_SUCCESS =
  'FETCH_COURSE_ADMIN_DATA_SUCCESS';
export const FETCH_COURSE_ADMIN_DATA_FAILURE =
  'FETCH_COURSE_ADMIN_DATA_FAILURE';

export const FETCH_COURSE_LANDING_PAGE_DATA_START =
  'FETCH_COURSE_LANDING_PAGE_DATA_START';
export const FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS =
  'FETCH_COURSE_LANDING_PAGE_DATA_SUCCESS';
export const FETCH_COURSE_LANDING_PAGE_DATA_FAILURE =
  'FETCH_COURSE_LANDING_PAGE_DATA_FAILURE';
export const ADD_COURSE_LANDING_PAGE_TEAM_MEMBER =
  'ADD_COURSE_LANDING_PAGE_TEAM_MEMBER';
export const REMOVE_COURSE_LANDING_PAGE_TEAM_MEMBER =
  'REMOVE_COURSE_LANDING_PAGE_TEAM_MEMBER';
export const UPDATE_COURSE_LANDING_PAGE_MEDIA =
  'UPDATE_COURSE_LANDING_PAGE_MEDIA';
export const UPDATE_COURSE_LANDING_PAGE_BLURB =
  'UPDATE_COURSE_LANDING_PAGE_BLURB';
export const UPDATE_COURSE_LANDING_PAGE_OUTCOMES_SUMMARY =
  'UPDATE_COURSE_LANDING_PAGE_OUTCOMES_SUMMARY';
export const UPDATE_COURSE_LANDING_PAGE_INTRODUCTION =
  'UPDATE_COURSE_LANDING_PAGE_INTRODUCTION';
export const UPDATE_COURSE_LANDING_PAGE_FURTHER_INFORMATION =
  'UPDATE_COURSE_LANDING_PAGE_FURTHER_INFORMATION';
export const UPDATE_COURSE_LANDING_PAGE_CPD_HOURS =
  'UPDATE_COURSE_LANDING_PAGE_CPD_HOURS';
export const TOGGLE_COURSE_LANDING_PAGE_HIDE_COST =
  'TOGGLE_COURSE_LANDING_PAGE_HIDE_COST';
export const UPDATE_COURSE_LANDING_DEFAULT_COHORT =
  'UPDATE_COURSE_LANDING_DEFAULT_COHORT';
export const SAVE_COURSE_LANDING_PAGE_START = 'SAVE_COURSE_LANDING_PAGE_START';
export const SAVE_COURSE_LANDING_PAGE_SUCCESS =
  'SAVE_COURSE_LANDING_PAGE_SUCCESS';
export const SAVE_COURSE_LANDING_PAGE_FAILURE =
  'SAVE_COURSE_LANDING_PAGE_FAILURE';

export const COPY_COURSE_START = 'COPY_COURSE_START';
export const COPY_COURSE_SUCCESS = 'COPY_COURSE_SUCCESS';
export const COPY_COURSE_FAILURE = 'COPY_COURSE_FAILURE';
export const HIDE_COPY_COURSE_SUCCESS_MODAL = 'HIDE_COPY_COURSE_SUCCESS_MODAL';
export const HIDE_COPY_COURSE_ERROR_MODAL = 'HIDE_COPY_COURSE_ERROR_MODAL';

export const FETCH_COURSE_ROLES_DATA_START = 'FETCH_COURSE_ROLES_DATA_START';
export const FETCH_COURSE_ROLES_DATA_SUCCESS =
  'FETCH_COURSE_ROLES_DATA_SUCCESS';
export const FETCH_COURSE_ROLES_DATA_FAILURE =
  'FETCH_COURSE_ROLES_DATA_FAILURE';

export const FETCH_CERTIFICATION_SETUP_DATA_START =
  'FETCH_CERTIFICATION_SETUP_DATA_START';
export const FETCH_CERTIFICATION_SETUP_DATA_SUCCESS =
  'FETCH_CERTIFICATION_SETUP_DATA_SUCCESS';
export const FETCH_CERTIFICATION_SETUP_DATA_FAILURE =
  'FETCH_CERTIFICATION_SETUP_DATA_FAILURE';

export const UPDATE_CERTIFICATION_TYPE = 'UPDATE_CERTIFICATION_TYPE';
export const UPDATE_CERTIFICATION_CODE = 'UPDATE_CERTIFICATION_CODE';
export const UPDATE_CERTIFICATION_DATA = 'UPDATE_CERTIFICATION_DATA';

export const SAVE_CERTIFICATION_START = 'SAVE_CERTIFICATION_START';
export const SAVE_CERTIFICATION_SUCCESS = 'SAVE_CERTIFICATION_SUCCESS';
export const SAVE_CERTIFICATION_FAILURE = 'SAVE_CERTIFICATION_FAILURE';

export const CONTENT_EDITOR_WALKTHROUGH_CLICKED =
  'CONTENT_EDITOR_WALKTHROUGH_CLICKED';
export const CONTENT_EDITOR_DIAGRAM_CLICKED = 'CONTENT_EDITOR_DIAGRAM_CLICKED';
export const CONTENT_EDITOR_SKIP_GUIDE_CLICKED =
  'CONTENT_EDITOR_SKIP_GUIDE_CLICKED';
export const CONTENT_EDITOR_OVERVIEW_DISMISSED =
  'CONTENT_EDITOR_OVERVIEW_DISMISSED';
export const CONTENT_EDITOR_ADD_PAGES_CLICKED =
  'CONTENT_EDITOR_ADD_PAGES_CLICKED';

export const CREATE_NEW_CLASS_CLICKED = 'CREATE_NEW_CLASS_CLICKED';
export const SHOW_CREATE_NEW_CLASS_MODAL = 'SHOW_CREATE_NEW_CLASS_MODAL';
export const HIDE_CREATE_NEW_CLASS_MODAL = 'HIDE_CREATE_NEW_CLASS_MODAL';
export const UPDATE_CREATE_OR_EDIT_CLASS_MODAL_COHORT =
  'UPDATE_CREATE_OR_EDIT_CLASS_MODAL_COHORT';
export const UPDATE_CREATE_OR_EDIT_CLASS_MODAL_ENROLMENT_TYPE =
  'UPDATE_CREATE_OR_EDIT_CLASS_MODAL_ENROLMENT_TYPE';
export const FETCH_COHORT_ACCESS_CODE_SUCCESS =
  'FETCH_COHORT_ACCESS_CODE_SUCCESS';
export const FETCH_COHORT_ACCESS_CODE_FAILURE =
  'FETCH_COHORT_ACCESS_CODE_FAILURE';
export const SUGGEST_NEW_ACCESS_CODE_SUCCESS =
  'SUGGEST_NEW_ACCESS_CODE_SUCCESS';
export const SUGGEST_NEW_ACCESS_CODE_FAILURE =
  'SUGGEST_NEW_ACCESS_CODE_FAILURE';
export const CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_FAILED =
  'CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_FAILED';
export const CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_PASSED =
  'CREATE_CLASS_MODAL_CLASS_NAME_VALIDATION_PASSED';
export const CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_FAILED =
  'CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_FAILED';
export const CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_PASSED =
  'CREATE_CLASS_MODAL_ACCESS_CODE_VALIDATION_PASSED';
export const CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_FAILED =
  'CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_FAILED';
export const CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_PASSED =
  'CREATE_CLASS_MODAL_STUDENT_PRICE_VALIDATION_PASSED';
export const CREATE_NEW_COHORT_START = 'CREATE_NEW_COHORT_START';
export const CREATE_NEW_COHORT_SUCCESS = 'CREATE_NEW_COHORT_SUCCESS';
export const CREATE_NEW_COHORT_FAILURE = 'CREATE_NEW_COHORT_FAILURE';
export const EDIT_CLASS_CLICKED = 'EDIT_CLASS_CLICKED';
export const SHOW_EDIT_CLASS_MODAL = 'SHOW_EDIT_CLASS_MODAL';
export const SAVE_COHORT_START = 'SAVE_COHORT_START';
export const SAVE_COHORT_SUCCESS = 'SAVE_COHORT_SUCCESS';
export const SAVE_COHORT_FAILURE = 'SAVE_COHORT_FAILURE';
